module.exports = __webpack_public_path__ + "static/img/matillion.8d6e65b6.png";